import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TextFieldComponent } from '../../../fields/standard/text-field/text-field.component';
import { PasswordFieldComponent } from '../../../fields/standard/password-field/password-field.component';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { FormBoxComponent } from '../../../ui/forms/form-box/form-box.component';
import { FormLabelComponent } from '../../../ui/forms/form-label/form-label.component';
import { FormSubmitButtonComponent } from '../../../ui/forms/form-submit-button/form-submit-button.component';
import { FormLinkComponent } from '../../../ui/forms/form-link/form-link.component';
import { PasswordRequirementsComponent } from '../../../ui/password-requirements/password-requirements.component';
import { HomeState } from '@mira-avant/mtlibs';

@Component({
	selector: 'app-reset-password-form',
	standalone: true,
	imports: [
		AppModule,
		ZorroModule,
		ThirdPartyModule,
		AngularModule,
		TextFieldComponent,
		PasswordFieldComponent,
		FormBoxComponent,
		FormLabelComponent,
		FormSubmitButtonComponent,
		FormLinkComponent,
		PasswordRequirementsComponent,
	],
	templateUrl: './reset-password-form.component.html',
	styleUrl: './reset-password-form.component.scss',
})
export class ResetPasswordFormComponent {
	@Output('onSubmit') public onSubmitEmitter: EventEmitter<any> = new EventEmitter<any>();
	@Output('onSwitchState') public onSwitchStateEmitter: EventEmitter<HomeState> = new EventEmitter<HomeState>();
	@Input('email') public email: string = '';
	@Input('loading') public loading: boolean = false;

	public form: FormGroup;

	constructor(private fb: FormBuilder) {
		this.form = this.fb.group({
			username: ['', [...TextFieldComponent.validators, Validators.required]],
			verificationCode: ['', [...TextFieldComponent.validators, Validators.required]],
			password: ['', PasswordFieldComponent.validators],
		});
	}

	ngOnInit() {
		this.form.patchValue({ username: this.email });
	}

	onSubmit(): void {
		if (this.form.valid) {
			this.onSubmitEmitter.emit(this.form.value);
		}
	}

	clear(): void {
		this.form.reset();
	}

	public onBack() {
		this.onSwitchStateEmitter.emit(HomeState.LOGIN);
	}
}
